import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'qumra-button',
  styleUrl: 'qumra-button.css',
  shadow: false,
})

export class QumraButton {
  @Prop() loaderPosition: string;
  @Prop() width: string;

  render() {
    const buttonClasses = {
      'qumra-checkout-button': true,
      [this.width]: !!this.width,
    };

    return (
      <button aria-label="UIButton" class={buttonClasses}>
        <slot></slot>
      </button>
    );
  }
}